import { Obj } from '@/types/common';

const redirectURIs: Obj<string> = {
  dev: import.meta.env.VITE_APPLE_URI_DEV,
  stage: import.meta.env.VITE_APPLE_URI_STAGE,
  prod: import.meta.env.VITE_APPLE_URI_PROD,
};

export function initAppleAuthService() {
  if (import.meta.env.MODE !== 'development') {
    const hostname = window.location.hostname.split('-')[0];
    const env = hostname === 'dev' || hostname === 'stage' ? hostname : 'prod';
    console.info(`Using environment: ${env}`);
    window.AppleID.auth.init({
      clientId: import.meta.env.VITE_APPLE_SERVICE_ID,
      scope: 'name email',
      redirectURI: redirectURIs[env] || '',
      usePopup: true, // Allows popup flow instead of full-page redirect
    });
  }
}
